import React, { useEffect, useState } from 'react';
import Input from '../Common/Input';
import moment from "moment-jalali";
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';
import InputMask from 'react-input-mask';
import SelectLocal from '../Common/Select.Local';
import Select from '../Common/Select';
import { useEntityCrud } from '../../hooks/useEntityCrud';

const type = [
    {
        value: 1,
        label: " بله"
    },
    {
        value: 2,
        label: "   خیر "
    }
]


const type2 = [
    {
        value: 1,
        label: " آنی"
    },
    {
        value: 2,
        label: "   بازه ی زمانی "
    }
]



const Form = ({ file, setFile, setCheckComment, checkComment, formik, fromdate, todate, setTodate, setFromdate, issuList, isEditMode, setOptions, options, issueType2, setIssueType2 }) => {


    const [subGuilds, setSubGuilds] = useState([]);
    const [guildId, setGuildId] = useState([]);
    const { readData: getSubGuilds } = useEntityCrud(`Guild/GetAllSubGuilds?guildId=${guildId}`);

    const setFileBase64 = async e => {
        document.getElementById('file-input-label').innerText = e.target.files[0].name;
        const fileData = await toBase64(e.target.files[0]);
        setFile(fileData.replace("data:image/jpeg;base64,", ""));
    }

    const toBase64 = async file => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }


    useEffect(() => {
        setGuildId(formik.values.guildId);
    }, [formik.values.guildId])


    useEffect(() => {
        getSubGuilds().then(({ data }) => {
            if (data.status) {
                let subGuilds = data.result;
                setSubGuilds(subGuilds);
            }
        });
    }, [guildId])
 
    return (
        <form onSubmit={formik.handleSubmit}>

            <div className="row">

                <div className="col-md-3" >
                    <Input label="عنوان" name="title" required={true} formik={formik} />
                </div>
                <div className="col-md-2">
                    <Select label="صنف" name="guildId" formik={formik} required={true}>
                        {options.filter(i => i.isActive).map(option => (
                            <option value={option.id} key={option.id}>{option.title}</option>
                        ))}
                    </Select>
                </div>
                <div className="col-md-2">
                    <Select label="زیر صنف" name="subGuildId" formik={formik} required={true} disabled={!subGuilds.length}>
                        {subGuilds.map(option => (
                            <option value={option.id} key={option.id}>{option.title}</option>
                        ))}
                    </Select>
                </div>
                <div className="col-md-2" style={{ position: "relative", zIndex: "5" }}>
                    <div className="form-group">
                        <label>از تاریخ</label>
                        <DatePicker
                            name="fromdate"
                            required
                            locale="fa"
                            calendarPopperPosition={"bottom"}
                            shouldHighlightWeekends
                            value={fromdate}
                            onChange={setFromdate}
                            className="form-control"
                        />
                    </div>
                </div>
                <div className="col-md-2 ">
                    <div className="form-group">

                        <label>  دارای بازه ی زمانی ؟  </label>
                        <br />
                        <select
                            className="form-control"
                            value={issueType2}
                            onChange={e => setIssueType2(e.target.value)}
                        >
                            <option  >انتخاب کنید </option>
                            <option value="1">بله</option>
                            <option value="2">خیر</option>
                        </select>

                    </div>
                </div>
                {issueType2 == 1 &&
                    <div className="col-md-1" >
                        <Input label="تعداد روزها "
                            name="issueDay" formik={formik} maxLength={3}
                        />
                    </div>
                }
                {(issueType2 == 2) && <div className="col-md-2" style={{ position: "relative", zIndex: "5" }}>
                    <div className="form-group">
                        <label>تا تاریخ</label>
                        <DatePicker
                            name="fromdate"
                            locale="fa"
                            minimumDate={fromdate}
                            calendarPopperPosition={"bottom"}
                            shouldHighlightWeekends
                            value={todate}
                            onChange={setTodate}
                            className="form-control"
                        />
                    </div>
                </div>
                }
            </div>
            <div className="row mt-2">

                <div className="col-md-3 ">
                    <SelectLocal label=" ارسال پیامک " name="issueType" formik={formik}
                        selectOption={type2} required={true}
                        optionValue={(item) => item.value} optionTitle={(item) => item.label} />
                </div>
                {formik.values.issueType == 2 && <>
                    <div className="col-md-2" >
                        <Input label={(formik.values.smsInterval || "0") + " ساعت " + "پس از انجام تراکنش"
                        }
                            name="smsInterval" formik={formik} maxLength={3}
                        />
                    </div>
                </>
                }



                <div className="col-md-3 d-flex align-items-end">
                    <div className="form-group">
                        <input
                            type="checkbox"
                            onChange={(e) => setCheckComment(e.target.checked)}
                        />
                        <label> انتقادات و پیشنهادات </label>
                    </div>
                </div>

            </div>

            <div className="row mt-2">
                <label >آپلود   لوگو</label>

                <div className="col-md-3">

                    <div className="form-group">

                        <div className="custom-file">
                            <input className="custom-file-input" onChange={setFileBase64} id="customFile" type="file"  accept="image/jpeg"/><label className="custom-file-label" id="file-input-label" htmlFor="customFile">انتخاب لوگو</label>
                        </div>

                        {isEditMode === true && <img src={file} style={{ margin: " 2% 0"  }}  accept="image/jpeg" />}
                        {isEditMode === false && <img src={"data:image/jpeg;base64," + file} exact="jpeg" style={{ margin: " 2% 0"  }} />}

                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-md-12 mt-4 pt-4 text-center">
                    <button className="btn btn-success mx-auto text-center" id="btn-submit-form">ذخیره اطلاعات</button>
                </div>
            </div>



        </form >
    );

}

export default Form;


